const errorStrings = {
  commonError: 'Something went wrong. Please contact support for help!',
  email: 'Enter a valid email!',
  password: 'Enter a valid password!',
  otp: 'Enter a valid otp.',
  name: 'Enter a valid name.',
};
export default errorStrings;
